import { Box, Button, Container, Typography } from '@mui/material';
import { getTranslation } from 'common';
import FlowentiButton from 'components/flowenti-ui-kit/FlowentiButton';
import { useTranslations } from 'hooks';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const LandingPageCTA = ({ lang }: { lang?: string }) => {
    const translations = useTranslations()
    useEffect(() => {
        if (lang) {
            // console.log("LandingPageCTA lang:", lang);
        }
    }, [lang]);

    return (
        <Box
            id="cta"
            sx={{
                py: { xs: 8, md: 12 },
                backgroundColor: '#ffffff',
            }}
        >
            <Container maxWidth="md">
                <Box
                    sx={{
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="h2"
                        component="h2"
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                            color: 'text.primary',
                            mb: 3,
                            lineHeight: 1.2,
                        }}
                    >
                        {getTranslation(translations, "landing_page.cta_title")}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.secondary',
                            fontSize: { xs: '1rem', md: '1.125rem' },
                            mb: 5,
                            maxWidth: '700px',
                            mx: 'auto',
                            lineHeight: 1.6,
                        }}
                    >
                        {getTranslation(translations, "landing_page.cta_description")}
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'center',
                            flexDirection: { xs: 'column', sm: 'row' },
                            alignItems: 'center',
                        }}
                    >
                        <FlowentiButton
                            component={Link}
                            to="/registration"
                            size="large"
                            variant="contained"
                        >
                            {getTranslation(translations, "generic.start_for_free")}
                        </FlowentiButton>
                        <FlowentiButton
                            size="large"
                            component={Link}
                            to="/support"
                            variant='outlined'
                        >
                            {getTranslation(translations, "support.title")}
                        </FlowentiButton>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default LandingPageCTA;